import BadgeIsNew from "@/components/ui/badge-isnew.";
import { Skeleton } from "@/components/ui/skeleton";
import { axiosApi } from "@/config/axios.config";
import { InfinityItems } from "@/features/Board/board-commentlist";
import { DateUtils } from "@/utils/dateUtil";
import { useInfiniteQuery } from "@tanstack/react-query";
import { IconRight } from "react-day-picker";

import { useNavigate } from "react-router-dom";

export default function HeroGuestboard() {
  const nav = useNavigate();

  const { data, isPending } = useInfiniteQuery({
    queryKey: ["GUESTBOARD"],
    queryFn: async ({ pageParam }) => {
      let endPoint = "/guestboard";
      const curCursor = pageParam === 0 ? undefined : pageParam;
      if (curCursor) {
        endPoint += `?cursor=${curCursor}`;
      }
      const response =
        await axiosApi.get<InfinityItems<typeof curCursor>>(endPoint);
      return response.data.result;
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.isNextPage) {
        return lastPage.list.at(-1)?.id;
      }
    },
    staleTime: 30 * 1000,
    gcTime: 60 * 1000,
    initialPageParam: 0,
  });

  if (isPending) {
    return (
      <div className=" flex flex-col gap-3 mt-1 ">
        <div className="flex gap-2 items-center mb-3">
          <Skeleton className="w-20 h-4" />
          <Skeleton className="w-10 h-4 rounded-full" />
        </div>
        {[...Array(3)].map((_, i) => (
          <div key={i} className="flex flex-col gap-1">
            <Skeleton className="h-3.5 w-3/4" />
            <Skeleton className="h-3.5 w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className=" h-full  rounded-lg flex flex-col gap-1 ">
      <div
        className="text-sm hover:opacity-100 hover:underline  opacity-50 mb-1 flex gap-2 items-center cursor-pointer  pb-2"
        onClick={() => nav("/guestboard")}
      >
        <span>Guest Board</span> <IconRight className="size-2" />
      </div>
      <div className="text-xs flex flex-col gap-3  mt-1 pl-4 border-l border-border">
        {data?.pages[0].list.slice(0, 3).map((e, idx) => {
          return (
            <a
              className=" hover:underline cursor-pointer  gap-1 inline-flex flex-col"
              key={`${e.id}:${idx}`}
              onClick={() => nav("/guestboard")}
            >
              <p className="inline-flex  items-center">
                <span className="line-clamp-1 text-sm md:text-xs max-w-[calc(100%-20px)]">
                  {e.comment}
                </span>
                <BadgeIsNew createAt={e.created_at} />
              </p>

              <p className="line-clamp-1 text-zinc-400  text-xs">
                {DateUtils.dateFormatKR(e.created_at, "YY. MM. DD")}
              </p>
            </a>
          );
        })}
      </div>
    </div>
  );
}
